import { Injectable } from '@angular/core';
import { DineroObject } from 'dinero.js';
import {
  BalanceSheetEntry,
  BalanceSheetEntryItem,
  BalanceSheetEntryReduction
} from '@secca/case/components/case-plans/case-plans/add-service-order/models/interfaces';
import { BalanceSheetProgress } from '../balance-sheet-event.model';
import { BalanceSheetEntryEnum, QuantityUnit } from '../enums';

export class ICCSplitInvoiceItemDto implements BalanceSheetEntry, BalanceSheetEntryItem {
  id: number;
  caseId: number;
  serviceOrderId: string;
  serviceItemCode: string;
  splitMoney: DineroObject;
  documentId: string;
  exchangeRate: number;
  splitMoneyCaseCurrency: DineroObject;
  invoiceNumber: string;
  supplierInvoiceId: string;
  creditorId: string;
  creditorName: string;
  invoiceDate: Date;
  receiveDate: Date;
  dueDate: Date;
  status: string;
  settledAmount: number;

  public constructor(init?: Partial<ICCSplitInvoiceItemDto>) {
    Object.assign(this, init);
  }

  // BalanceSheetEntryItem
  getServiceOrderId(): string {
    return this.serviceOrderId;
  }
  getServiceItemCode(): string {
    return this.serviceItemCode;
  }
  getQuantityUnit(): string {
      return QuantityUnit.pcs;
  }
  getQuantity(): number {
      return 1;
  }

  getIsIncludingVAT(): boolean {
      return false;
  }
  getIsInVATCreditorGroup(): boolean {
      return false;
  }
  getSavings(): BalanceSheetEntryReduction[] {
    return [];
  }

  // BalanceSheetEntry
  getId(): number {
      return this.id;
  }
  getType(): BalanceSheetEntryEnum {
      return BalanceSheetEntryEnum.SUPPLIER_INVOICE_PART;
  }
  getInvoiceNumber(): string {
      return this.invoiceNumber;
  }
  getInvoiceDocumentId(): string {
      return this.documentId;
  }
  getItems(): BalanceSheetEntryItem[] {
    return [this];
  }
  getCreditorId(): string {
      return this.creditorId;
  }
  getCreditorName(): string {
      return this.creditorName;
  }
  getOriginalAmount(): number {
    return this.splitMoney.amount;
  }
  getInvoiceAmountExchanged(): DineroObject {
    return this.splitMoneyCaseCurrency;
  }
  getInvoiceAmount(): DineroObject {
    return this.splitMoney;
  }
  getInvoiceAmountCurrency(): string {
    return this.splitMoney.currency;
  }
  getInvoiceDate(): Date {
      return this.invoiceDate;
  }
  getReceivedDate(): Date {
    return this.receiveDate;
  }
  getDueDate(): Date {
    return this.dueDate;
  }
  getStatus(): string {
    return this.status;
  }
  getRedStatusText(): string {
      return 'Den røde text';
  }
  getStakeholderId(): number {
      return -1;
  }
  getReductionAmount(): number {
    return 0;
  }
  setReductionAmount(amount: number) {
    console.log('trying to reduce something but we are unbounded');
  }
  getSettledAmount(): number {
      return this.settledAmount;
  }
  setSettledAmount(amount: number) {
    this.settledAmount = amount;
  }
  getProgress(): BalanceSheetProgress {
    return null;
  }
  getExchangeRate(): number {
      return this.exchangeRate;
  }
  getMedicalEscort(): boolean {
    return false;
  }
  isCancelled(): boolean {
      return false;
  }
  isObjection(): boolean {
      return false;
  }
  isDeleted(): boolean {
      return false;
  }

}

@Injectable({
  providedIn: 'root'
})
export class ICCSplitInvoiceItemDtoAdapter {
  adaptDirect(item: any): ICCSplitInvoiceItemDto {
    console.log('hello');
    console.log(item.creditorName);
    return new ICCSplitInvoiceItemDto({
      id: item.id,
      caseId: item.caseId,
      serviceOrderId: item.serviceOrderId,
      serviceItemCode: item.serviceItemCode,
      splitMoney: item.splitMoney,
      documentId: item.documentId,
      splitMoneyCaseCurrency: item.splitMoneyCaseCurrency,
      exchangeRate: item.exchangeRate,
      invoiceNumber: item.invoiceNumber,
      supplierInvoiceId: item.supplierInvoiceId,
      creditorId: item.creditorId,
      creditorName: item.creditorName,
      invoiceDate: item.invoiceDate,
      receiveDate: item.receiveDate,
      dueDate: item.dueDate,
      status: item.status,
    });
  }
}
